import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {environment} from '@drl/env/environment';
import {PermissionKey} from '@drl/core/auth/permission-key.enum';
import {AuthGuard} from '../core/auth/auth.guard';
import {CsvUploadReportComponent} from './csv-upload-report/csv-upload-report.component';
import { DataUploadComponent } from './data-upload/data-upload.component';

const routes: Routes = [
  // {
  //   path: 'home',
  //   loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewAnyUser],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'patients',
    loadChildren: () => import('./patients/patients.module').then(m => m.PatientsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewPatient],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'online-appoinments',
    loadChildren:
      () => import('./online-appoinments/online-appoinments.module').then(m => m.OnlineAppoinmentsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewPatient],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'care-groups',
    loadChildren: () => import('./care-groups/care-groups.module').then(m => m.CareGroupsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewPatient],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'cms',
    loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewCMSContent],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'configurations',
    loadChildren: () => import('./configurations/configurations.module').then(m => m.ConfigurationsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ManageOwnTenantConfig],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'diet-plans',
    loadChildren: () => import('./diet-plans/diet-plans.module').then(m => m.DietPlansModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewDietPlan],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'care-central',
    loadChildren: () => import('./care-central/care-central.module').then(m => m.CareCentralModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.CanSeeCareCentral],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewOwnUser],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'csv-report',
    component: CsvUploadReportComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.UpsertBulkEhrData],
        redirectTo: environment.homePath,
      },
    },
  },
  {
    path: 'data-upload',
    loadChildren: () => import('./data-upload/data-upload.module').then(m => m.DataUploadModule),
    component: DataUploadComponent,
    canActivate: [NgxPermissionsGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: [PermissionKey.ViewOwnUser],
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
